import React from 'react';
import { useLocale } from '../i18n/LocaleContext';

function Dashboard({ tasks, logs }) {
  const { t, dateLocale } = useLocale();
  const completedTasks = tasks.length;

  return (
    <div className="dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-info"><h3>{t('dashboard.completedBuilds')}</h3><p className="stat-number">{completedTasks}</p></div>
        </div>
      </div>

      <div className="recent-activity">
        <div className="section-heading">{t('dashboard.recentActivity')}</div>
        <div className="activity-list">
          {logs.length === 0 && <p className="no-logs">{t('dashboard.emptyActivity')}</p>}
          {logs.slice(-10).reverse().map((log, i) => (
            <div key={i} className={`activity-item ${log.level}`}>
              <span className="activity-time">{new Date(log.timestamp).toLocaleTimeString(dateLocale)}</span>
              <span className="activity-message">{log.message}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
